import { Box } from '@mui/system';
import styled from 'styled-components';

export const HotlistInfoWrapper = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 24px;
  background-color: ${({ theme }) => theme.palette.base.background};
  box-shadow: ${({ theme }) => theme.shadows[26]};
  border-radius: 8px;
`;

export const InputHotlistWithLabel = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  @media (max-width: 1441px) {
    min-width: 25%;
  }
`;

export const SingleHotlistWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
`;

export const DefaultsWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 32px;
  width: 100%;
  flex-wrap: wrap;
  @media (min-width: 900px) {
    .MuiChip-deletable {
      max-width: 300px;
    }
  }
  > .MuiBox-root {
    max-width: 100%;
    width: auto;
  }
  input#search-input {
    height: 32px;
  }
  .MuiChip-filled {
    top: 12px;
  }
`;

export const HotlistButtonWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 12px;
  border-top: 1px solid ${({ theme }) => theme.palette.grey[200]};
  padding-top: 24px;
`;

export const NotesCellWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.palette.grey[50]};
  margin: 0 24px 16px;
  padding: 12px 24px;
`;

export const NotesLabel = styled(Box)`
  color: ${({ theme }) => theme.palette.base.primary};
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
`;

export const NotesContent = styled(Box)`
  color: ${({ theme }) => theme.palette.grey[900]};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  word-break: break-all;
`;

export const NotesInput = styled.input`
  color: ${({ theme }) => theme.palette.grey[900]};
  background-color: ${({ theme }) => theme.palette.grey[50]};
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  border: none;
  outline: none;
  width: 100%;
  word-break: break-all;
`;
